export const RECURRING_TASK_DEADLINE_OFFSET_DAYS_PREFIX = 'offset_days:'

export const parseRecurringTaskDeadlineDefaultValue = (
  value: string | null | undefined,
): number | null => {
  if (value == null) return null

  const trimmed = value.trim()
  if (!trimmed) return null

  if (trimmed.startsWith(RECURRING_TASK_DEADLINE_OFFSET_DAYS_PREFIX)) {
    const days = Number(
      trimmed.slice(RECURRING_TASK_DEADLINE_OFFSET_DAYS_PREFIX.length),
    )

    if (!Number.isFinite(days) || days < 0) return null

    return Math.floor(days)
  }

  const days = Number(trimmed)
  if (!Number.isFinite(days) || days < 0) return null

  return Math.floor(days)
}

export const serializeRecurringTaskDeadlineDefaultValue = (offsetDays: number) =>
  `${RECURRING_TASK_DEADLINE_OFFSET_DAYS_PREFIX}${Math.floor(offsetDays)}`

export const formatRecurringTaskDeadlineOffsetLabel = (
  value: string | null | undefined,
): string => {
  const offsetDays = parseRecurringTaskDeadlineDefaultValue(value)
  if (offsetDays == null) return 'Не указан'

  if (offsetDays === 0) {
    return 'В день создания задачи'
  }

  const mod10 = offsetDays % 10
  const mod100 = offsetDays % 100

  if (mod10 === 1 && mod100 !== 11) {
    return `Через ${offsetDays} день от создания задачи`
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return `Через ${offsetDays} дня от создания задачи`
  }

  return `Через ${offsetDays} дней от создания задачи`
}
